import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { JuridictionResponseDto } from 'lib_api/lib/api/gen';

import { useApi } from '../ApiStoreContext';
import { useHandleBackErrors } from '../utils/handleBackErrors';

export function useRefJuridiction(
  idCorrelation: string | undefined | null,
  queryKeyLabel: string,
): UseQueryResult<JuridictionResponseDto | undefined> {
  const { ReferentielControllerApi } = useApi();
  const behaviourOnError = useHandleBackErrors();

  function fetchJuridiction(): Promise<JuridictionResponseDto | undefined> {
    if (!idCorrelation) {
      return Promise.resolve(undefined);
    }
    return ReferentielControllerApi.getLastJuridictionByIdCorrelationUsingGET(
      idCorrelation,
    ).catch((error: Response) => {
      behaviourOnError(error);
      return Promise.reject(error);
    });
  }

  return useQuery({
    queryKey: [queryKeyLabel, idCorrelation],
    queryFn: fetchJuridiction,
    enabled: !!idCorrelation,
  });
}
